export default {"src":"/_next/static/media/filter.df2e3489.svg","height":14,"width":21,"blurWidth":0,"blurHeight":0};